<template>
  <div class="teamWrappers">
    <div class="mainContainer">
      <van-row>
        <van-col span="24" style="text-align: center;margin-top:20px;margin-bottom: 16px">
          <span style="font-weight: bold;color: black;font-size: 0.4rem">{{teamName}}</span>
        </van-col>
      </van-row>

      <div class="teamStudyPartContainer" >
        <van-row type="flex" justify="center"  ref="innerObj" style="padding: 10px 0px;width: 100%;">
          <van-col span="24" v-for="(v,i) in mediaTeamUserList" :key="i">
            <van-card  class="mdTmyCard" :class="v.learn_rank==1?'firstC':v.learn_rank==2?'firstC':v.learn_rank==3?'firstC':'anthorC'">
              <template #thumb style="width: auto;">
                <van-image
                  round
                  fit="cover"
                  :width="v.learn_rank==1?'70px':v.learn_rank==2?'70px':v.learn_rank==3?'80px':'60px'"
                  :height="v.learn_rank==1?'70px':v.learn_rank==2?'70px':v.learn_rank==3?'80px':'60px'"
                  :src="v.head_url?v.head_url:'/minio/gyfw/school/defaultImg.png'"
                />
              </template>
              <template #title>
                <span style="font-weight: bolder;font-size:0.4rem;width: 80px;display: inline-block">{{v.name}}</span>
                <span style="padding-left: 20px">{{formatSeconds2(v.learn_total_time)}}</span>
                <!--<span style="padding-left: 20px">{{9999}}时{{9999}}分</span>-->
              </template>
              <template #desc>
                <div style="padding-top: 8px;font-size: 0.4rem"  >
                  <span style="font-size: 14px;color: #a6a6a6">暂无荣誉</span>
                  <!--<van-icon name="star-o" size="inherit" color="orange" style="padding-left: 2px" />-->
                  <!--<van-icon name="like-o" size="inherit" color="orange" style="padding-left: 2px" />-->
                  <!--<van-icon name="fire-o" size="inherit" color="orange"  style="padding-left: 2px"/>-->
                  <!--<van-icon name="gem-o" size="inherit" color="orange"  style="padding-left: 2px"/>-->
                  <span style="float: right;padding-right: 10px" :style="v.learn_rank==1?'color:red':v.learn_rank==2?'color:orange':v.learn_rank==3?'color:blue':'color:silver'">{{v.learn_rank}}</span>
                </div>

              </template>
            </van-card>
            <van-divider  :style="{ padding: '0 16px'}" />
          </van-col>

        </van-row>
      </div>

    </div>
    <tab/>
  </div>
</template>
<script>
  import Tab from './tab';
  import { mediaLearn, getInfo,mediaTeamInfoGet,mediaTeamGet } from '@/api/shopapi';
  export default {
    name: 'mediaTeamUserList',
    components: {
      Tab,
    },
    data () {
      return {
        recommendList:[],
        mediaLearnData:{},
        learn_total_time:0,
        learn_total_ratio:0,
        activeName: 'a',
        buyList:[],
        studyPlanList:[],
        activeName2:'1',
        mediaTeamList:[],
        mediaTeamUserList:[],
        teamName:''
      }

    },
    computed: {
      learnTime(){
        return this.formatSeconds(this.learn_total_time)
      }

    },
    async mounted () {
      this. mediaTeamUserList=this.$store.getters.getMediaTeamUserList
      this.teamName = this.$route.query.teamName
      const res = await mediaLearn({info_type:0,page_no: 0,
        page_size: 10000000})
      if(res.code=='000'){
        console.log('resmediaLearn',res)
        this.mediaLearnData=res.data
        if(res.data.last_info_list&&res.data.last_info_list.length>0){
          let arr=res.data.last_info_list.filter(x=>{
            if(x.file_duration!==0){
              return x
            }
          })
          this.$nextTick(()=>{
            this.recommendList = arr.map(m=>{
              m.info_bg = m.info_bg || '../../../static/img/bg/ept2.jpg'
              return m
            })
          })

          this.buyList=res.data.buy_list.filter(f=>f.info)
        }
        this.learn_total_time=res.data.learn_total_time
        console.log('his.learn_total_time',res.data.learn_total_time)
        this.learn_total_ratio=res.data.learn_total_ratio
      }
      const teamInfoRes=await mediaTeamInfoGet({team_id:null,page_no: 0, page_size: 10000000})
      if(res.code=='000'){
        console.log('mediaTeamInfoGet',teamInfoRes)
        this.studyPlanList=teamInfoRes.data.data_list
      }else{
        console.log('学习计划获取失败')
      }
      const mediaTeamGetRes=await mediaTeamGet()
      if(mediaTeamGetRes.code=='000'){
        console.log('mediaTeamGetRes',mediaTeamGetRes)
        this.mediaTeamList=mediaTeamGetRes.data
      }else{
        console.log('获取学习小组失败')
      }
    },
    methods: {

      s_to_hs(s){
        //计算分钟
        //算法：将秒数除以60，然后下舍入，既得到分钟数
        var h;
        h  =   Math.floor(s/60);
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s  =   s%60;
        //将变量转换为字符串
        h    +=    '';
        s    +=    '';
        //如果只有一位数，前面增加一个0
        h  =   (h.length==1)?'0'+h:h;
        s  =   (s.length==1)?'0'+s:s;
        return h+':'+s;
      },
      formatSeconds(value) {
        let result = parseInt(value)
        let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
        let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
        let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
        result = `${h}<span style="font-size: 0.3rem;"> 时</span><span style="font-size: 0.4rem"> ${m} </span><span style="font-size: 0.3rem;">分</span>`
        return result
      },
      formatSeconds2(value) {
        console.log('value',value)
        let result = parseInt(value)
        let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
        let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
        let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
        result = `${h} 小时 ${m}分`
        return result
      },
      toFixed(number, decimal) {
        decimal = decimal || 0;
        var s = String(number);
        var decimalIndex = s.indexOf('.');
        if (decimalIndex < 0) {
          var fraction = '';
          for (var i = 0; i < decimal; i++) {
            fraction += '0';
          }
          return s + '.' + fraction;
        }
        var numDigits = s.length - 1 - decimalIndex;
        if (numDigits <= decimal) {
          var fraction = '';
          for (var i = 0; i < decimal - numDigits; i++) {
            fraction += '0';
          }
          return s + fraction;
        }
        var digits = s.split('');
        var pos = decimalIndex + decimal;
        var roundDigit = digits[pos + 1];
        if (roundDigit > 4) {
          //跳过小数点
          if (pos == decimalIndex) {
            --pos;
          }
          digits[pos] = Number(digits[pos] || 0) + 1;
          //循环进位
          while (digits[pos] == 10) {
            digits[pos] = 0;
            --pos;
            if (pos == decimalIndex) {
              --pos;
            }
            digits[pos] = Number(digits[pos] || 0) + 1;
          }
        }
        //避免包含末尾的.符号
        if (decimal == 0) {
          decimal--;
        }
        return digits.slice(0, decimalIndex + decimal + 1).join('');
      },
      resizeTabs(){
        console.log('1221212')
        this.$refs.vanTabs.resize();
      },

    }
  }
</script>
<style scoped>
  .mainContainer{
    width: 100%;
    height: auto;
    background-color: #fafafa;
    padding-bottom: 50px;
  }
  .topArea{
    display: flex;
    height: 150px;
  }
  .topPart{
    width: 50%;
    text-align: center;
    vertical-align: center;
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;

    text-align: justify;
    background: transparent;
    margin:0 auto;
    color:black;

  }


  .itemI{
    margin: 10px 10px;
  }
  .itemI .van-card__thumb {
    width: 35% !important;
  }
  .itemI .van-image__img {
    border-radius: 0 ;
  }
  .item2{
    width:  100%;
  }
  .tab-item{
    width: 100%;
  }
  .teamStudyPartContainer{
    flex: 1;
    margin: 0px 10px 0px 10px;
    width: calc(100vw - 20px);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    background: white;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .studyPart{
    flex-wrap: wrap;
    background-color: white;
    justify-content: flex-start;
    height: 200px;
  }
  .teamWrappers{
    background-color: #faf5ee
  }
  .mdTmyCard{
    padding: 0rem 0.426667rem;
    background-color: white;
  }
  .oneLine{
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    display: inline-block;
  }
  .firstC .van-card__thumb{
      height: 90px;
    min-height:90px;
  }
  .secondC .van-card__thumb{
      height: 1.8rem;
  }
  .mdTmyCard .van-card__thumb{
    height: 90px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content:center;
    margin-right: 0px!important;
  }
  .mdTmyCard .van-card__thumb .van-image{
    height: 1.1rem;
    text-align: center;
    display: inline-flex!important;
  }
  .mdTmyCard .van-card__content{
    min-height: 1.9rem;
    padding-left: 8px;

  }
  .mdTmyCard .van-card__header{
       align-items: center

  }
</style>

